/**
 * AuthManager — handles player login, identity, and session persistence.
 */
export default class AuthManager {
    constructor() {
        this.playerName = '';
        this.playerUUID = '';
    }

    /**
     * Restore the last used player name from localStorage.
     */
    restoreLastName() {
        return localStorage.getItem('last_player_name') || '';
    }

    /**
     * Attempt login: validate name, persist it, connect via networkManager.
     * Returns { uuid, name } on success, or null if name is empty.
     */
    async login(name, networkManager) {
        const trimmed = name.trim();
        if (!trimmed) return null;

        this.playerName = trimmed;
        localStorage.setItem('last_player_name', trimmed);

        const info = await networkManager.connect(trimmed);
        this.playerUUID = info.uuid;
        this.playerName = info.name || trimmed;

        return { uuid: this.playerUUID, name: this.playerName };
    }
}
